import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Button, Empty, Table } from 'antd'
import { ColumnsType } from 'antd/lib/table'
import { ArrowLeftOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { getJobsTurnoverBySro, ITurnoverBySroItem } from '../../reducers/jobs/actions'
import { history } from '../../utils/history'

const formatEur = (value: number) => `${(Math.round((value || 0) * 100) / 100).toLocaleString('sk-SK', { minimumFractionDigits: 0, maximumFractionDigits: 2 })} €`

const TurnoverBySro = () => {
	const dispatch = useDispatch()
	const { t } = useTranslation('pages')

	const [rows, setRows] = useState<ITurnoverBySroItem[]>([])
	const [totals, setTotals] = useState({ totalTurnover: 0, totalJobs: 0 })
	const [isLoading, setIsLoading] = useState(false)

	useEffect(() => {
		setIsLoading(true)
		dispatch(getJobsTurnoverBySro((data) => {
			setRows(data.data)
			setTotals(data.context)
			setIsLoading(false)
		}, () => setIsLoading(false)))
	}, [dispatch])

	const goToJobs = (row: ITurnoverBySroItem) => {
		const base = t('paths:jobs|path')
		if (row.firmHeaderId != null) {
			history.push(`${base}?priceOfferFirmHeaderIDs=${row.firmHeaderId}`)
		} else {
			history.push(`${base}?withoutFirmHeader=1`)
		}
	}

	const columns: ColumnsType<ITurnoverBySroItem> = [
		{
			title: t('pages:s.r.o.'),
			dataIndex: 'firmName',
			key: 'firmName',
			render(value: string | null) {
				return value || <span style={{ color: 'rgba(0, 0, 0, 0.45)' }}>{t('pages:Bez s.r.o.')}</span>
			}
		},
		{
			title: t('pages:Počet zákaziek'),
			dataIndex: 'jobsCount',
			key: 'jobsCount',
			align: 'right',
			width: 170,
			sorter: (a: ITurnoverBySroItem, b: ITurnoverBySroItem) => a.jobsCount - b.jobsCount
		},
		{
			title: t('pages:Mesačný obrat'),
			dataIndex: 'turnover',
			key: 'turnover',
			align: 'right',
			width: 190,
			sorter: (a: ITurnoverBySroItem, b: ITurnoverBySroItem) => a.turnover - b.turnover,
			render(value: number) {
				return <span style={{ fontWeight: 500 }}>{formatEur(value)}</span>
			}
		}
	]

	return (
		<div className={'page-wrapper'}>
			<div className={'flex justify-between items-center mb-4'}>
				<h2 style={{ margin: 0 }}>{t('pages:Obraty po s.r.o.')}</h2>
				<Button icon={<ArrowLeftOutlined />} onClick={() => history.push(t('paths:jobs|path'))}>
					{t('pages:Späť na zákazky')}
				</Button>
			</div>
			<Table
				className={'general-table'}
				rowKey={(record: ITurnoverBySroItem) => (record.firmHeaderId == null ? 'none' : String(record.firmHeaderId))}
				columns={columns}
				dataSource={rows}
				loading={isLoading}
				pagination={false}
				onRow={(record: ITurnoverBySroItem) => ({ onClick: () => goToJobs(record) })}
				rowClassName={() => 'cursor-pointer'}
				locale={{ emptyText: <Empty description={t('pages:Žiadne dáta')} /> }}
				footer={() => (
					<div style={{ display: 'flex', alignItems: 'center', fontWeight: 500 }}>
						<div style={{ flex: 1 }}>{t('pages:Spolu')}</div>
						<div style={{ width: 170, textAlign: 'right' }}>{totals.totalJobs}</div>
						<div style={{ width: 190, textAlign: 'right' }}>{formatEur(totals.totalTurnover)}</div>
					</div>
				)}
				size={'middle'}
			/>
		</div>
	)
}

export default TurnoverBySro
